
export enum AppLanguage {
    ENGLISH = 'en',
    DEUTSCH = 'de',
}
